export default __webpack_public_path__ + "static/media/OceanFinancialCentre.jpg?.d405a308";